import Button, { ButtonSize, ButtonStyle } from 'components/common/Button';
import { EntryMethod } from 'components/enter/EntryMethod';
import RoundedButton from 'components/RoundedButton';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ENTER_CTA_LINK, ENTER_FLOW_FIRST_STEP } from 'utils/cta/CTA';
import styles from './EnterButton.module.css';

interface Props {
  dm2026Button?: boolean;
  overrideButtonText?: string;
  overrideReferralText?: boolean;
  buttonStyle?: ButtonStyle;
  buttonSize?: ButtonSize;
}

/** An button that takes the user to the first page of the enter flow. Its text will change depending on some state.
 * See implementation for details
 */
export const EnterButton = observer(
  ({
    dm2026Button,
    overrideButtonText,
    overrideReferralText,
    buttonStyle,
    buttonSize,
  }: Props) => {
    const enterStore = useEnterStore();

    const href = enterStore.isReferralFlow
      ? ENTER_FLOW_FIRST_STEP
      : ENTER_CTA_LINK;
    const onClick = () =>
      enterStore.isReferralFlow &&
      enterStore.setEntryMethod(EntryMethod.PremiumSubscription);

    const referralText = 'Claim 50% Off';

    const buttonText =
      enterStore.isReferralFlow && overrideReferralText && overrideButtonText
        ? overrideButtonText
        : enterStore.isReferralFlow
          ? referralText
          : overrideButtonText
            ? overrideButtonText
            : 'Enter to Win';

    if (dm2026Button) {
      return (
        <Button
          buttonStyle={buttonStyle ?? 'Primary'}
          buttonSize={buttonSize ?? 'Medium'}
          onClick={onClick}
          href={href}
          fullWidth="flex1"
        >
          {buttonText}
        </Button>
      );
    }

    return (
      <span className={styles.ctaButton}>
        <RoundedButton
          href={href}
          onClick={onClick}
          rebrandDm2025
          colorStyle="Primary"
          fullWidth
        >
          {buttonText}
        </RoundedButton>
      </span>
    );
  },
);
